// extracted by mini-css-extract-plugin
export default {"input":"Name_input__RFhLV"};